import React from 'react';
import { format } from 'date-fns';

const formatMap = {
  'Y-m-d': 'yyyy-MM-dd',
  'd-m-Y': 'dd-MM-yyyy',
  'm-d-Y': 'MM-dd-yyyy',
  // 'd-M-Y': 'dd-MMM-yyyy',
  'j-n-Y': 'd-M-yyyy',

  // Slash (/) date formats
  'Y/m/d': 'yyyy/MM/dd',
  'd/m/Y': 'dd/MM/yyyy',
  'm/d/Y': 'MM/dd/yyyy',
  // 'd/M/Y': 'dd/MMM/yyyy',
  'j/n/Y': 'd/M/yyyy',

  // 24-hour time formats
  'H:i': 'HH:mm',
  'H:i:s': 'HH:mm:ss',
  'H.i': 'HH.mm',
  'H.i.s': 'HH.mm.ss',

  // 12-hour time formats
  'h:i A': 'hh:mm a',
  'h:i:s A': 'hh:mm:ss a',
  'h:i a': 'hh:mm a',
  'h:i:s a': 'hh:mm:ss a',
};

export const formatDatePreview = (dateFormat) => {
    const now = new Date();
    const preview = formatMap[dateFormat] ? format(now, formatMap[dateFormat]) : 'Invalid format';
    return `${dateFormat} (${preview})`;
};

export const formatTimePreview = (timeFormat) => {
    const now = new Date();
    const preview = formatMap[timeFormat] ? format(now, formatMap[timeFormat]) : 'Invalid format';
    return `${timeFormat} (${preview})`;
};